<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section class="d-flex justify-content-end">
      <b-btn variant="primary" @click="$bvModal.show('modal-add-ban')">Add Ban</b-btn>
    </section>

    <section class="my-2">

      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>Sender First Name</label>
          <b-form-input
            @keyup.enter="searchBans()"
            v-model="filters.firstname"
            class="mb-1" placeholder="Enter first name"
          />
        </section>

        <section class="col-3">
          <label>Sender Last Name</label>
          <b-form-input
            @keyup.enter="searchBans()"
            v-model="filters.lastname"
            class="mb-1" placeholder="Enter last name"
          />
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="searchBans()" v-model="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="user_firstname">Name (A-Z)</b-form-select-option>
            <b-form-select-option value="-user_firstname">Name (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3 align-items-center d-flex" style="margin-top: 8px">
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchBans()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="bans"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
        >
          <template #cell(name)="data">
            {{data.item.user_firstname}} {{data.item.user_lastname}}
          </template>
          <template #cell(duration)="data">
            {{data.item.start_date | formatDate}} - {{data.item.end_date | formatDate}}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(reason)="data">
            <div>{{data.item.reason.substr(0, 100)}}
              <b-button class="tooltip-custom" id="tooltip-target-1" v-if="data.item.reason.length > 100">
              ...
              </b-button>
            </div>
            <b-tooltip target="tooltip-target-1" triggers="hover">
              {{data.item.reason}}
            </b-tooltip>
          </template>
          <template #cell(actions)="data">
            <b-btn @click="showUpdateBanModal(data.item)"
                   variant=""
                   class="mr-1">Update</b-btn>
            <b-btn @click="showBanModal(data.item, 'modal-delete-ban')"
                   variant="danger"
                   class="">Remove</b-btn>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getBans()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No banned users</p>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-delete-ban" title="Remove ban" hide-footer>
      <warning-modal v-if="selectedBan" @close="closeModals()" @ok="deleteBan(selectedBan)"
        :subtitle="selectedBan.user_firstname + ' ' + selectedBan.user_lastname"
        title="Are you sure you wish to remove ban?"></warning-modal>
    </b-modal>

    <b-modal id="modal-add-ban" title="Add ban" hide-footer>
      <add-ban @refresh="getBans" @close="closeModals"></add-ban>
    </b-modal>

    <b-modal id="modal-update-ban" title="Update ban" hide-footer>
      <update-ban :ban="selectedBan" @refresh="getBans" @close="closeModals" />
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
  import AddBan from '@/views/postView/sections/AddBan.vue';
  import UpdateBan from '@/views/postView/sections/UpdateBan.vue';
  import HelperService from '../../services/HelperService';
  import BanService from '../../services/BanService';
  import WarningModal from '../../components/modals/WarningModal.vue';

  export default {
    name: 'BannedUsers',
    components: {
      UpdateBan,
      WarningModal,
      AddBan,
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        selectedBan: null,
        headers: [
          { label: 'Name', key: 'name' },
          { label: 'Ban Duration', key: 'duration' },
          { label: 'Updated', key: 'updated_at' },
          { label: 'Reason', key: 'reason' },
          { label: '', key: 'actions' },
        ],
        bans: [],
        currentPage: 1,
        totalRows: 10,
        filters: {
          firstname: '',
          lastname: '',
          skip: 1,
          sort: '-updated_at',
          limit: 10,
        },
      };
    },
    computed: {},
    watch: {
      currentPage() {
        this.getBans();
      },
    },
    mounted() {
      this.getBans();
    },
    methods: {
      searchBans() {
        this.currentPage = 1;

        this.getBans();
      },
      closeModals() {
        this.$bvModal.hide('modal-add-ban');
        this.$bvModal.hide('modal-delete-ban');
        this.$bvModal.hide('modal-update-ban');
        this.setSelectedBan(null);
      },
      getBans() {
        this.filters.skip = (this.currentPage - 1) * this.filters.limit;
        this.closeModals();

        BanService.getAllBans(this.filters).then(res => {
          this.loading = false;
          this.bans = res.data.data;
          this.totalRows = res.data.count;
        }).catch(err => {
          console.log('Error getting bans ', err);
          this.$toast.error('Could not get bans, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      clearFilters() {
        this.filters = {
          firstname: '',
          lastname: '',
          skip: 1,
        };

        this.searchBans();
      },
      setSelectedBan(ban) {
        this.selectedBan = ban;
      },
      showBanModal(ban, modalName) {
        this.setSelectedBan(ban);
        this.$bvModal.show(modalName);
      },
      showUpdateBanModal(ban) {
        console.log('>>> ban details: ', ban);
        this.setSelectedBan(ban);
        this.$bvModal.show('modal-update-ban');
      },
      deleteBan(ban) {
        // eslint-disable-next-line no-underscore-dangle
        BanService.deleteBan(ban._id).then(() => {
          this.$toast.success(`Removed ban ${ban.user_firstname} ${ban.user_lastname} Successfully`, {
            toastClassName: ['toast-std', 'success-toast'],
          });

          this.getBans();
        }).catch(err => {
          console.log('error deleting ban', err);
          this.$toast.error('Could not remove ban, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
    },
  };
</script>
